import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import CustomerEntry from './components/CustomerEntry';
import CustomerRegistration from './components/CustomerRegistration';
import AdminPanel from './components/AdminPanel';
import PointsSummary from './components/PointsSummary';
import { Login } from './pages/Login';
import { EstablishmentRegister } from './pages/EstablishmentRegister';
import { PrivateRoute } from './components/PrivateRoute';
import { useEstablishmentStore } from './store/establishment';

function App() {
  const { establishment, loading, checkAuth } = useEstablishmentStore();

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-purple-500 border-t-transparent"></div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={
        establishment ? <Navigate to="/" replace /> : <Login />
      } />
      <Route path="/register" element={
        establishment ? <Navigate to="/" replace /> : <EstablishmentRegister />
      } />
      
      <Route path="/" element={
        establishment ? (
          <CustomerEntry />
        ) : (
          <Navigate to="/login" replace />
        )
      } />
      
      <Route path="/registration/:phone" element={
        <PrivateRoute>
          <CustomerRegistration />
        </PrivateRoute>
      } />
      
      <Route path="/admin" element={
        <PrivateRoute>
          <AdminPanel />
        </PrivateRoute>
      } />
      
      <Route path="/points-summary/:phone" element={
        <PrivateRoute>
          <PointsSummary />
        </PrivateRoute>
      } />
      
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;